import React, { useState, useRef } from 'react';
import { Icon, ClassHelper, Error } from 'components/lib';
import Style from './inputFileUpload.module.scss';
import { Backdrop } from '@mui/material';
import { MediaGrid } from '../../NodeLayout/CodeEditorComponents/MediaGrid';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';



function InputFileUpload({ maxFileSize, file, index, handleUMFormInputChange, imageFullUrl, props }) {
  const [openUrl, setOpenUrl] = useState();
  const [valid, setValid] = useState(true);
  const [error, setError] = useState(props?.errorMessage || 'Please select a image file');
  const fileInputRef = useRef();

  function validate(file) {

    // check the file type
    if (!/^image\/(jpeg|png|jpg)$/.test(file.type)) {
      setValid(false);
      setError('Only JPEG, PNG, and JPG images are allowed');
      return false;
    }
    //  Check the file size
    if (maxFileSize && file.size > (1024 * maxFileSize)) {
      setValid(false);
      setError(`Max filesize: ${maxFileSize}kb`);
      return false;
    }
    // eslint-disable-next-line no-unused-vars
    const data = {
      name: file.name,
      data: file,
      url: URL.createObjectURL(file),
      size: file.size,
      type: file.type
    }
    handleUMFormInputChange(file, 'upload', index);

  }

  const handleDrop = (event) => {
    event.preventDefault();
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };
  const fileStyle = ClassHelper(Style, {
    dropzone: true,
    error: !valid,
  });

  return (
    <div key={props?.index}>
      {openUrl &&
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <ClickAwayListener onClickAway={() => { setOpenUrl() }}>
            <div style={{ backgroundColor: 'white' }}>
              <MediaGrid
                mediaLinks={[openUrl]}
                openOnClick={false}
                isImage={props?.onlyImage}
                allowOverflow={true}
              />
            </div>
          </ClickAwayListener >
        </Backdrop>
      }
      <div className={fileStyle}
        onDragOver={handleDragOver}
        onDrop={e => {
          handleDrop(e);
          validate(e.dataTransfer?.files[0])
        }}
        style={
          {
            border: '1px dashed #aaa',
            borderRadius: '5px',
            padding: '12px 4px',
            textAlign: 'center',
            minHeight: '8.5em',
            display: "flex",
            alignItems: "center"
          }}
      >
        <input
          type="file"
          id="fileInput"
          accept=".png, .jpeg, .jpg"
          style={{ display: 'none' }}
          ref={fileInputRef}
          onChange={e => {
            validate(e.target?.files[0])
          }}
        />
        {imageFullUrl ?
          <>
            <div className={Style.imageUrl}>
              <p
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  const url = imageFullUrl;
                  setOpenUrl(url);
                }}
              >
                View
              </p>
              
              {file?.name ?
                <>
                  <div>
                    <Icon image={'check'} className={Style.labelIcon} />
                    <div className={Style.labelText}>{file?.name}</div>
                  </div>
                </>
                : <div style={{ cursor: 'pointer' }} onClick={e => fileInputRef.current.click()} >
                  <Icon image={'upload'} className={Style.labelIcon} />
                  <div className={Style.labelText}>Change image</div>
                </div>
              }
            </div>
          </> :
          <div onClick={e => fileInputRef.current.click()} className={Style.label} style={{ cursor: 'pointer' }}>
            {/* If the image is selected then it shows  */}
            {file?.name ?
              <>
                <Icon image={'check'} className={Style.labelIcon} />
                <div className={Style.labelText}>{file?.name}</div>
              </>
              :
              <>
                <Icon image={'upload'} className={Style.checkIcon} />
                <div className={Style.labelText}>Drop image here</div>
              </>
            }
          </div>}

      </div>
      {!valid &&
        <div>
          <Error message={error} />
        </div>
      }
    </div>
  );
}
export default InputFileUpload;